// src/mixins/notification/toasts.js
import Vue from 'vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import i18n from '@/libs/i18n'
import { showToastSafe } from '@/utils/notification/toastAdapter'

// -------- Vue 2 mixin (component usage via this.$toast) --------
export const showToast = {
  methods: {
    // Backward compatible
    showToast(response, element, title = null, timeout = 4000, options = null) {
      if (options && typeof options === 'object') {
        // New: pass options through (subject/text/successText/errorText/...)
        showToastSafe(this, response, { element, subject: title || 'Notification', timeout, ...options })
      } else {
        showToastSafe(this, response, element, title || 'Notification', timeout)
      }
    },
  },
}

// -------- Plain-module helper (NO useToast / NO inject) --------
function getToastInstance() {
  const t = Vue.prototype.$toast
  return t || ((..._args) => {})
}

export const customToast = () => {
  const toast = getToastInstance()

  // You can keep this, but now it’s redundant because showToastSafe supports custom texts.
  const showCustomToast = (response, element, title = null, customSuccessText = null, timeout = 2000) => {
    let icon, text, variant
    const status = response?.status
    const statusText = response?.statusText || 'Notification'

    switch (status) {
      case 'success':
      case 200:
      case 201:
        icon = 'BellIcon'
        text = i18n.t(customSuccessText) || `👋 ${i18n.t(element)} - ${i18n.t(statusText)}`
        variant = 'success'
        break
      case 'error':
        icon = 'AlertOctagonIcon'
        text = `${i18n.t(element)} - ${i18n.t(statusText)}`
        variant = 'danger'
        break
      default:
        icon = 'AlertCircleIcon'
        text = `${i18n.t(element)} - ${i18n.t(statusText)}`
        variant = 'warning'
    }

    toast(
        {
          component: ToastificationContent,
          props: {
            title: i18n.t(title) || i18n.t('Notification'),
            icon,
            text,
            variant,
          },
        },
        { timeout }
    )
  }

  return { showCustomToast }
}

export const _ = null
